import { Create, Edit, List, Show, Barcode } from "../Components/index.js";

export default [{ path: "/store/menu", component: List, name: "store-menu-list" }];
